import { BaseModel } from "../Generics/BaseModel"

export class ChangePasswordRequestDto extends BaseModel {
  currentPassword: string

  newPassword: string

  constructor(data: Partial<ChangePasswordRequestDto> = {}) {
    super()

    this.currentPassword = data.currentPassword ?? ""

    this.newPassword = data.newPassword ?? ""
  }
}
